export default "__VITE_ASSET__BFMWI3$I__"